export default __webpack_public_path__ + "static/media/logout.41952927.svg";